import { useEffect } from 'react';

export const usePaginationValidation = (
  count: number | undefined,
  currentPage: number,
  pageLimit: number,
  setPage: (page: number) => void,
) => {
  useEffect(() => {
    if (count !== undefined) {
      const maxPage = Math.max(1, Math.ceil(count / pageLimit) || 1);
      if (currentPage > maxPage) {
        setPage(maxPage);
      }
    }
  }, [count, currentPage, pageLimit, setPage]);
};
